var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-base search-container"},[_c('search-label-body',{attrs:{"label":_vm.label}},[_c('div',{staticClass:"pt-3"},[_c('search-nav-company-ids',{attrs:{"label":""},on:{"input":_vm.change},model:{value:(_vm.companies),callback:function ($$v) {_vm.companies=$$v},expression:"companies"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }